import { lazy } from "react";

/**
 * Ánh xạ slug (lưu trong D1, quản lý qua /admin) sang component trang thật.
 * Thêm tool mới trong admin không tự có trang — phải code component rồi
 * thêm 1 dòng vào đây thì route /tools/:slug mới render được.
 * Slug chưa có trong registry sẽ tự hiện "Sắp ra mắt" ở trang chủ.
 */
export const toolRegistry: Record<string, React.LazyExoticComponent<() => JSX.Element>> = {
  "tiktok-downloader": lazy(() => import("../pages/TikTokDownloader")),
};
